<template>
	<div class="ks-videoeditor-inline">
		<slot></slot>
		<input type="range" min="0" max="100" :value="value" :disabled="disabled" class="ks-videoeditor-volume" @input="change($event.target.value)">
		<k-text-field type="number" :value="value" style="width: 70px;" @input="change"></k-text-field>
		<span>%</span>
	</div>
</template>

<script>
// 0-100 % slider with a number field; the default slot goes before the slider
export default {
	props: {
		value: Number,
		disabled: Boolean
	},
	methods: {
		change (value) {
			const v = parseFloat(value);
			if (!isNaN(v)) this.$emit("input", _.clamp(Math.round(v), 0, 100));
		}
	}
}
</script>
